import type { I18nKeyModifier } from "app/pages/sales-intelligence/modules/leads-search/containers/leads-actions/SaveToListButton/types";
import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";

export const tableActionsI18KeyModifier: Record<LeadsType, I18nKeyModifier> = {
    [LeadsType.Companies]: "move-company",
    [LeadsType.Websites]: "move_to_list",
};
